import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Button as MuiButton,
  Typography,
} from "@mui/material";
import NextPlanOutlinedIcon from "@mui/icons-material/NextPlanOutlined";
import { useCreate, useNotify, useRefresh } from "react-admin";
import { useState } from "react";
import { getDataProviderErrorMessage } from "../../../dataproviders/normalizeError";
import { canSubmitSubscriberApplication } from "./subscriberSubmitPolicy";

interface SubscriberApplicationRecord {
  id?: number | string;
  ApplicationType?: string;
  ApplicationStatus?: string;
}

interface SubscriberSubmitActionProps {
  record?: SubscriberApplicationRecord;
  userRole?: unknown;
  isDocUploadView?: boolean;
}

export const SubscriberSubmitAction = ({
  record,
  userRole,
  isDocUploadView,
}: SubscriberSubmitActionProps) => {
  const [open, setOpen] = useState(false);
  const [create, { isLoading }] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!canSubmitSubscriberApplication(
    record?.ApplicationType,
    record?.ApplicationStatus,
    userRole,
    isDocUploadView
  )) {
    return null;
  }

  const handleSubmit = () => {
    if (record?.id === undefined || record.id === null) {
      notify("Unable to submit Verification Request", { type: "error" });
      return;
    }

    create(
      "submitapplication",
      { data: { ApplicationNumber: record.id } },
      {
        onSuccess: () => {
          setOpen(false);
          notify("Verification Request submitted for review", { type: "success" });
          refresh();
        },
        onError: (error) => {
          notify(
            getDataProviderErrorMessage(error, "Unable to submit Verification Request"),
            { type: "error" }
          );
        },
      }
    );
  };

  return (
    <>
      <IconButton
        type="button"
        aria-label="Submit"
        onClick={() => setOpen(true)}
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: 0,
          color: "#1CA2C2",
          px: 1,
          py: 0.5,
          "&:hover": { backgroundColor: "#EAF9FD" },
        }}
      >
        <NextPlanOutlinedIcon fontSize="small" />
        <Typography component="span" sx={{ fontSize: 12, lineHeight: 1.2 }}>
          Submit
        </Typography>
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Submit Verification Request?</DialogTitle>
        <DialogContent>
          Are you sure you want to submit this Verification Request for review?
        </DialogContent>
        <DialogActions>
          <MuiButton type="button" onClick={() => setOpen(false)} disabled={isLoading}>
            Cancel
          </MuiButton>
          <MuiButton type="button" onClick={handleSubmit} disabled={isLoading} variant="contained">
            Submit
          </MuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
